// extracted by mini-css-extract-plugin
var _1 = "NotificationsPopup_author__PLKUM";
var _2 = "NotificationsPopup_board__w3vuq";
var _3 = "NotificationsPopup_date__PryMR";
var _4 = "NotificationsPopup_empty__S7WT-";
var _5 = "NotificationsPopup_firstItemButton__sD58i";
var _6 = "NotificationsPopup_item__3h3ud";
var _7 = "NotificationsPopup_itemButton__effAQ";
var _8 = "NotificationsPopup_itemContent__lNp9x";
var _9 = "NotificationsPopup_itemHeader__Ry60k";
var _a = "NotificationsPopup_itemRead__WDL-1";
var _b = "NotificationsPopup_project__6I6VN";
var _c = "NotificationsPopup_user__PRUuj";
var _d = "NotificationsPopup_wrapper__a5zac";
export { _1 as "author", _2 as "board", _3 as "date", _4 as "empty", _5 as "firstItemButton", _6 as "item", _7 as "itemButton", _8 as "itemContent", _9 as "itemHeader", _a as "itemRead", _b as "project", _c as "user", _d as "wrapper" }
